import _ from 'lodash';

export function dynamicSortMultiple(...args) {
    const props = args;
    return (obj1, obj2) => {
        let i = 0;
        let result = 0;
        const numberOfProperties = props.length;
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i])(obj1, obj2);
            i += 1;
        }
        return result;
    };
}

export function dynamicSort(_property) {
    let sortOrder = 1;
    let property = _property;
    if (property[0] === '-') {
        sortOrder = -1;
        property = _property.substr(1);
    }

    return (a, b) => {
        let result = 0;
        // equal items sort equally
        if (a[property] === b[property]) {
            result = 0;
        } else if (a[property] === 0 || a[property] === null) {
            // If property equals 0 or null put at end of list
            result = 1;
        } else if (b[property] === 0 || b[property] === null) {
            result = -1;
        } else if (a[property] < b[property]) {
            // otherwise, if we're ascending, lowest sorts first

            result = -1;
        } else if (a[property] > b[property]) {
            // if descending, highest sorts first
            result = 1;
        }
        return result * sortOrder;
    };
}

export function sortRoomTypes(roomTypes, availability, showNewFirst) {
    if (showNewFirst) {
        return _.orderBy(
            roomTypes,
            [
                (roomType) => _.get(roomType, `${availability}`) > 0,
                'acceptingProvisionalBookings',
                'renewalDuration',
            ],
            ['desc', 'desc', 'desc'],
        );
    }
    return _.orderBy(
        roomTypes,
        [(roomType) => _.get(roomType, `${availability}`) > 0, 'renewalDuration'],
        ['desc', 'desc', 'desc'],
    );
}
